import { IExceptionTelemetry, SeverityLevel } from "@microsoft/applicationinsights-web";
import { CieloPagamentoModel } from "../../model/CieloPagamentoModel";
import { ClearsalePagamentoModel } from "../../model/ClearsalePagamentoModel";
import LogUtil from "../../util/LogUtil";
import ProxyBaseDAO from "./ProxyBaseDAO";

class ProxyPagamentoDAO extends ProxyBaseDAO {
  private static instance: ProxyPagamentoDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyPagamentoDAO {
    if (!ProxyPagamentoDAO.instance) {
      ProxyPagamentoDAO.instance = new ProxyPagamentoDAO();
    }
    return ProxyPagamentoDAO.instance;
  }

  public async getCardBin(card: string, storeId: number): Promise<string> {
    return this.get(
      `REQ_PROXY_CARD_BIN_${card}`,
      `${this.endpoint}/oba/payment/cardbin?cardNumber=${card}&storeId=${storeId}`,
    ).then((r: any) => {
      return r.data.data.provider;
    });
  }

  public async postPayment(pagto: CieloPagamentoModel): Promise<any> {
    return this.post(
      `${this.endpoint}/oba/payment`,
      pagto
    ).then((r: any) => {
      return r.data;
    });
  }

  public async postClearsale(pagto: ClearsalePagamentoModel): Promise<any> {
    return this.post(
      'https://oba-webapp-api-dev.azurewebsites.net/api/ClearSale/token/',
      {
        name: 'RedeOba_T',
        password: '4HeIcbLm52'
      }
    ).then((ret: any) => {
      if (ret && ret.data && ret.data.token) {
        return this.postWithConfig('https://oba-webapp-api-dev.azurewebsites.net/api/ClearSale/order/', pagto, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${ret.data.token}`
          },
          crossDomain: true,
        });
      }
    }).catch((ex) => {
      LogUtil.logException({
        exception: ex,
        severityLevel: SeverityLevel.Critical,
      } as IExceptionTelemetry);
    });
  }
}

export default ProxyPagamentoDAO;
